import staticStiles from './arrows.module.scss';
import { ArrowRight } from '@/assets';

export const Arrows = ({ styles }: { styles: string }) => {
  return (
    <div className={`${staticStiles.arrows} ${styles}`}>
      <ArrowRight />
      <ArrowRight />
    </div>
  );
};
